import defaultImage from '../images/imageNotFound.jpeg';

// Import new images for the mapping
import acintyaBhedabhedaTattvaImg from '../images/Acintya-bhedābheda-tattva.jpeg';
import isvaraTattvaImg from '../images/Īśvara-tattva.jpeg';
import jivaTattvaImg from '../images/Jīva-tattva.jpeg';
import gauraTattvaImg from '../images/Gaura-Tattva.jpeg';
import guruTattvaImg from '../images/Guru-Tattva.jpeg';
import krsnaTattvaImg from '../images/Kṛṣṇa-Tattva.jpeg';
import lilaTattvaImg from '../images/Līlā-Tattva.jpeg';
import namaTattvaImg from '../images/Nāma-tattva.jpeg';
import rasaTattvaImg from '../images/Rasa-Tattva.jpeg';
import saktiTattvaImg from '../images/Śakti-Tattva.jpeg';
import sambhuTattvaImg from '../images/Śambhu-Tattva.jpeg';
import sadhanaBhaktiImg from '../images/Sādhanā-Bhakti.jpeg';
import raganugaBhaktiImg from '../images/Rāgānuga-Bhakti.jpeg';
import bhavaPremaBhaktiImg from '../images/Bhāva-and-Prema-Bhakti.jpeg';
import limbsBhaktiImg from '../images/Limbs-of-Bhakti.jpeg';
import stagesBhaktiImg from '../images/Stages-of-Bhakti.jpeg';
import gloriesBhaktiImg from '../images/Glories-of-Bhakti.jpeg';
import unspokenObstaclesImg from '../images/unspokenObstacles.jpg';
import understandingPrabhupadaStatementsImg from '../images/Understanding-Śrīla-Prabhupāda_s-statements.jpeg';
import goodBadLeadershipImg from '../images/GoodBad-leadership.jpeg';
import mixedDevotionalServiceImg from '../images/Mixed-Devotional-Service.jpeg';
import practicalDevotionalServiceImg from '../images/Practical-Devotional-Service.jpeg';
import associationDevoteesImg from '../images/associationOfDevotees.jpeg';
import classificationDevoteesImg from '../images/Classification-of-Devotees.jpeg';
import dealingsDevoteesImg from '../images/Dealings-with-Devotees.jpeg';
import devoteeRelationshipsImg from '../images/Devotee-Relationships.jpeg';
import gloriesQualitiesDevoteesImg from '../images/Glories_Qualities-of-Devotees.jpeg';
import behaviorPerfectedDevoteesImg from '../images/Behavior-of-Perfected-devotees.jpeg';
import anarthasAnarthaNivrttiImg from '../images/Anarthas_Anartha-nivṛtti.jpeg';
import anukulyasyaSankalpahPratikulyasyaVarjanamImg from '../images/Ānukūlyasya-saṅkalpaḥ-prātikūlyasya-varjanam.jpeg';
import offensesImg from '../images/Offenses.jpeg';
import muktiImg from '../images/Mukti.jpeg';
import srimadBhagavadGitaImg from '../images/Śrīmad-Bhagavad-gītā.jpeg';
import srimadBhagavatamImg from '../images/Śrīmad-Bhāgavatam.jpeg';
import sriCaitanyaCaritamrtaImg from '../images/Śrī-Caitanya-caritāmṛta.jpeg';
import srimadBhagavatamPastimesImg from '../images/Śrīmad-Bhāgavatam-pastimes.jpeg';
import studyingSastrasImg from '../images/Studying-Śāstras.jpeg';
import avatarasImg from '../images/Avatāras.jpeg';
import krsnasTuBhagavanSvayamImg from '../images/Kṛṣṇas-tu-bhagavān-svayam.jpeg';
import gauraLilaImg from '../images/Gaura-lila.jpeg';
import dhamsDhamVasisImg from '../images/Dhāms_Dhām-vāsīs.jpeg';
import spiritualWorldImg from '../images/Spiritual-World.jpeg';
import creationDissolutionMaterialWorldImg from '../images/Creation_Dissolution-of-the-Material-World.jpeg';
import threeModesImg from '../images/Three-modes.jpeg';
import lawOfKarmaImg from '../images/Law-of-Karma.jpeg';
import karmaYogaImg from '../images/Karma-Yoga.jpeg';
import otherYogasImg from '../images/Other-Yogas.jpeg';
import varnasramaImg from '../images/Varṇāśrama.jpeg';
import demigodWorshipImg from '../images/Demigod-Worship.jpeg';
import clarificationsBhaktiSiddhantaImg from '../images/Clarifications-on-Bhakti-Siddhānta.jpeg';
import siddhantaVicaraImg from '../images/Siddhānta-Vicāra.jpeg';
import refutingApaSiddhantaImg from '../images/Refuting-Apa-Siddhānta.jpeg';
import parallelsBhaktiOtherPathsImg from '../images/Parallels-Between-Bhakti-and-Other-Paths.jpeg';
import chastityParamparaImg from '../images/Chastity-to-the-Paramparā.jpeg';
import deviationDegradationParamparaImg from '../images/Deviation-and-degradation-of-a-Paramparā.jpeg';
import specialityGaudiyaVaisnavaParamparaKrsnaBhaktiImg from '../images/Speciality-of-the-Gauḍīya-Vaiṣṇava-Paramparā_Kṛṣṇa-Bhakti.jpeg';
import vaisnavaSampradayasImg from '../images/Vaiṣṇava-sampradāyas.jpeg';
import preachingImg from '../images/Preaching.jpeg';
import vrajaPremaImg from '../images/Vraja-Prema.jpeg';



// Mapping of section names to their respective images using new naming pattern
export const fullHeightAccordionImageMap: { [key: string]: string } = {
    // Philosophy & Tattva
    'Acintya-bhedābheda-tattva': acintyaBhedabhedaTattvaImg,
    'Īśvara tattva': isvaraTattvaImg,
    'Jīva-tattva': jivaTattvaImg,
    'Gaura-Tattva': gauraTattvaImg,
    'Guru-Tattva': guruTattvaImg,
    'Kṛṣṇa Tattva': krsnaTattvaImg,
    'Līlā-Tattva': lilaTattvaImg,
    'Nāma-tattva': namaTattvaImg,
    'Rasa Tattva': rasaTattvaImg,
    'Śakti Tattva': saktiTattvaImg,
    'Śambhu-Tattva': sambhuTattvaImg,

    // Bhakti Practice
    'Sādhanā Bhakti': sadhanaBhaktiImg,
    'Rāgānuga Bhakti': raganugaBhaktiImg,
    'Bhāva and Prema Bhakti': bhavaPremaBhaktiImg,
    'Limbs of Bhakti': limbsBhaktiImg,
    'Stages of Bhakti': stagesBhaktiImg,
    'Glories of Bhakti': gloriesBhaktiImg,
    'Obstacles to Bhakti': unspokenObstaclesImg,
    'Mixed Devotional Service': mixedDevotionalServiceImg,
    'Practical Devotional Service': practicalDevotionalServiceImg,

    // Devotee Topics
    'Association of Devotees': associationDevoteesImg,
    'Classification of Devotees': classificationDevoteesImg,
    'Dealings with Devotees': dealingsDevoteesImg,
    'Devotee Relationships': devoteeRelationshipsImg,
    'Glories/Qualities of Devotees': gloriesQualitiesDevoteesImg,
    'Behavior of Perfected devotees': behaviorPerfectedDevoteesImg,

    // Spiritual Development
    'Anarthas/Anartha-nivṛtti': anarthasAnarthaNivrttiImg,
    'Ānukūlyasya saṅkalpaḥ prātikūlyasya varjanam': anukulyasyaSankalpahPratikulyasyaVarjanamImg,
    'Offenses': offensesImg,
    'Mukti': muktiImg,

    // Scriptures & Study
    'Śrīmad Bhagavad-gītā': srimadBhagavadGitaImg,
    'Śrīmad-Bhāgavatam': srimadBhagavatamImg,
    'Śrī Caitanya-caritāmṛta': sriCaitanyaCaritamrtaImg,
    'Śrīmad-Bhāgavatam Pastimes': srimadBhagavatamPastimesImg,
    'Studying Śāstras': studyingSastrasImg,

    // Other Topics
    'Avatāras': avatarasImg,
    'kṛṣṇas tu bhagavān svayam': krsnasTuBhagavanSvayamImg,
    'Gaura lila': gauraLilaImg,
    'Dhāms/Dhām vāsīs': dhamsDhamVasisImg,
    'Spiritual World': spiritualWorldImg,
    'Creation/Dissolution of the Material World': creationDissolutionMaterialWorldImg,
    'Three Modes': threeModesImg,
    'Law of Karma': lawOfKarmaImg,
    'Karma Yoga': karmaYogaImg,
    'Other Yogas': otherYogasImg,
    'Varṇāśrama': varnasramaImg,
    'Demigod Worship': demigodWorshipImg,

    // Philosophical Discussions
    'Clarifications on Bhakti Siddhānta': clarificationsBhaktiSiddhantaImg,
    'Siddhānta-Vicāra': siddhantaVicaraImg,
    'Refuting Apa-Siddhānta': refutingApaSiddhantaImg,
    'Parallels Between Bhakti and Other Paths': parallelsBhaktiOtherPathsImg,

    // Tradition & Practice
    'Chastity to the Paramparā': chastityParamparaImg,
    'Deviation and degradation of a Paramparā': deviationDegradationParamparaImg,
    'Speciality of the Gauḍīya Vaiṣṇava Paramparā/Kṛṣṇa Bhakti': specialityGaudiyaVaisnavaParamparaKrsnaBhaktiImg,
    'Vaiṣṇava sampradāyas': vaisnavaSampradayasImg,
    'Preaching': preachingImg,
    'Vraja Prema': vrajaPremaImg,
    'Good/Bad Leadership': goodBadLeadershipImg,
    'Understanding Śrīla Prabhupāda\'s statements': understandingPrabhupadaStatementsImg,
};

// Export function to get image for a section
export const getFullHeightAccordionImage = (sectionName: string): string => {
    return fullHeightAccordionImageMap[sectionName] || defaultImage;
}; 